export default {"src":"/_next/static/media/WhoWeAre_048A.1fdeff6b.JPG","height":708,"width":1920};